export function applyMasonry(container: HTMLElement, rowHeight: number): void {
  // Ensure the grid auto row size matches the provided rowHeight (in px)
  container.style.gridAutoRows = `${rowHeight}px`;

  const items = container.querySelectorAll<HTMLElement>('.card__image');
  items.forEach(item => {
    item.style.height = 'auto';
    const itemHeight: number = item.offsetHeight;
    const computed = window.getComputedStyle(container);
    const gapValue = computed.getPropertyValue('row-gap') || computed.getPropertyValue('grid-row-gap');
    const rowGap: number = parseFloat(gapValue) || 0;
    const rowSpan: number = Math.ceil((itemHeight + rowGap) / (rowHeight + rowGap));
    item.style.gridRowEnd = `span ${rowSpan}`;
    item.style.height = '100%';
  });
}
